require('./brokerProductFileView.scss');

const PropTypes = require('prop-types');

// @vendor
const React = require('react');
import { withRouter } from 'react-router-dom';
const { connect } = require('react-redux');
const iframeResizer = require('iframe-resizer');
// @actions
const ProductFileActions = require('actions/brokerGetProductFile.js');
const BrokerOpenTraderActions = require('actions/brokerOpenTrader');
const BrokerClientWarningModalAction = require('actions/brokerClientWarningModal');
const PredictionDetailActions = require('actions/brokerIA/brokerIAGetPredictionDetail.js');
// @commons
const { formatText, FormattedText, getLanguage } = require('core/i18n').i18n;
const TabbedBox = require('components/commons/tabbedBox/tabbedBox');
const { ContentBox } = require('commonsComponents/contentBox');
const { OKCover } = require('commonsComponents/OKCover');
const { OKButton } = require('components/commons/OKButton/OKButton');
// @components
const BrokerStocksHeader = require('components/broker/brokerProductHeaders/brokerStocksHeader/brokerStocksHeader');
const DetailsTab = require('components/broker/brokerProductFileTabs/detailsTab.js');
const TechAnalysisTab = require('components/broker/brokerProductFileTabs/technicalAnalysisTab.js');
const NewsTab = require('components/broker/brokerProductFileTabs/newsTab.js');
const BrokerTruncatedBreadcrumb = require('components/broker/brokerTruncatedBreadcrumb/brokerTruncatedBreadcrumb');
const { scrollToTop } = require('commonsUtilities/scrollUtils');
// @constatns
const { STOCK_DETAILS, OPENTRADER } = require('constants/flagBasedFeatures');
const { MYPROFILE_BROKER_EXPLORE_URL, BROKER_INFO_SCREEN } = require('constants/index');
const { PROC_BROKER__PRODUCT_FILE } = require('utilities/tagging');
const { NOT_ALLOWED_WEALTH_BROKER_IA_COUNTRIES} = require('constants/flagBasedFeatures');
//@helpers
const { taggingEventHandled } = require('utilities/taggingEventHandled');

const WebappRender = require('components/conditionalRender/webappRender')

import FeatureTogglingRender from 'components/conditionalRender/featureTogglingRender';

import BrokerIAProductBanner from 'components/broker/brokerIA/brokerIAComponents/brokerIAProductBanner/brokerIAProductBanner';
import Disclaimers from 'components/broker/brokerIA/brokerIAComponents/shared/disclaimers/disclaimers';

class BrokerProductFileView extends React.Component {

    constructor(props) {
        super(props);
        this.getProductDetails = this.getProductDetails.bind(this);
    }

    componentWillMount() {
        this.getProductDetails();
        this.props.getProductCatalogueDetails(this.props.match.params.isin);
    }

    componentDidMount() {
        this.props.checkPersonalInformationData();
        iframeResizer.iframeResizer();
        scrollToTop();
        const customData = { nombrePagina: 'broker/producto', productName: this.props.match.params.isin };
        window && window.utag && window.utag.view && window.utag.view(customData);
    }

    componentWillReceiveProps = (nextProps) => {
        if ( nextProps.productFile !== this.props.productFile) {
          this.getBrokerIAPredictionDetail();
        }
      }

    getBrokerIAPredictionDetail() {
        const { productFile, flagBasedFeatures, immProfile  } = this.props;
        const brokerIAFlag = flagBasedFeatures.get(NOT_ALLOWED_WEALTH_BROKER_IA_COUNTRIES);
        const brokerIAEnabled = !!brokerIAFlag && !brokerIAFlag.includes(immProfile.get('originCountry'));

        if ( brokerIAEnabled && !productFile.get('error') && productFile.get('isFetched') && !productFile.get('isFetching')
        && productFile.get('isinCode') === this.props.match.params.isin) {
            this.props.getPredictionDetail(this.props.match.params.isin,
                productFile.get('micCode'),
                productFile.get('currency'));
        }
    }

    getProductDetails() {
        const { getProductDetails, match: { params: { isin, iso } } } = this.props;
        getProductDetails(isin, iso, BROKER_INFO_SCREEN);
    }

    renderTabs = () => {
        const { productFile, match: { params: { isin, iso } } } = this.props;
        const detailsInfo = {
            min: productFile.get('yearLow'),
            max: productFile.get('yearHigh'),
            ytd: productFile.get('yearChangePercentage'),
            variation: productFile.get('yearChangePrice'),
            currency: productFile.get('productValueCurrency'),
            isin,
            iso
        };
        const language = getLanguage() === 'es' ? 'es' : getLanguage();
        const CONSENSUS_IFRAME_URL = `https://openbank-analisis.webfg.com/consenso/${productFile.get('micCode')}/${productFile.get('isinCode')}/${language}`;
        const IFRAME_URL = `https://openbank-analisis.webfg.com/fundamental/${iso}/${isin}/${language}`;
        return [
            {
                label: <div onClick={() => taggingEventHandled(PROC_BROKER__PRODUCT_FILE, 'brokerProductFile', 'details')}>{formatText('broker-productFileDetailTab')}</div>,
                content: <DetailsTab key="broker-details-tab" details={detailsInfo} />
            },
            {
                label: <div onClick={() => taggingEventHandled(PROC_BROKER__PRODUCT_FILE, 'brokerProductFile', 'technical analysis')}>{formatText('broker-productFileTechnicalAnalysisTab')}</div>,
                content: <TechAnalysisTab key="broker-tech-analysis-tab" miccode={iso} isinCode={isin} />
            },
            {
                label: <div onClick={() => taggingEventHandled(PROC_BROKER__PRODUCT_FILE, 'brokerProductFile', 'fundamental analysis')}>{formatText('broker-productFileFundamentalAnalysisTab')}</div>,
                content: <iframe key="broker-fund-analysis-tab" className="broker-product-file-view__iframe" src={IFRAME_URL} />
            },
            {
                label: <div onClick={() => taggingEventHandled(PROC_BROKER__PRODUCT_FILE, 'brokerProductFile', 'market consensus')}>{formatText('broker-productFileMarketConsensusTab')}</div>,
                content: <iframe key="broker-market-consensus-tab" className="broker-product-file-view__iframe" src={CONSENSUS_IFRAME_URL} />
            },
            {
                label: <div onClick={() => taggingEventHandled(PROC_BROKER__PRODUCT_FILE, 'brokerProductFile', 'news')}>{formatText('broker-productFileNewsTab')}</div>,
                content: <NewsTab key="broker-news-tab" isinCode={isin} />
            }
        ];
    }

    renderProductFileContent = () => {
        const { productFile } = this.props;
        if (!productFile.get('error') && productFile.get('isFetched') && !productFile.get('isFetching')) {
            return (
                <ContentBox customClassName="broker-product-file-body">
                    <TabbedBox
                        onlyTabs
                        onlyContent
                        id="brokerProductFile"
                        tabs={this.renderTabs()}
                        customClassName="broker-product-file-view__content"
                    />
                </ContentBox>
            );
        }
        return null;
    }

    renderPredictionDetail = () => {
        const { predictionDetail, productFile } = this.props;
        if (!predictionDetail.get('error') && predictionDetail.get('isFetched') && !predictionDetail.get('isFetching') && productFile.get('productValue')){
            return (
                <BrokerIAProductBanner
                    predictionDetail={predictionDetail}
                    currentPrice={productFile.get('productValue').get('amount')}
                />
            );
        }
        return null;

    }

    render() {
        const { productFile, immMyInvestments, onOpenTraderClick, flagBasedFeatures,immProfile, predictionDetail, match: { params: { isin, iso } }, immFlagBasedFeatures } = this.props;
        const productFileSubTitleStocks = formatText('broker-productFileSubTitleStocks');
        const riskScale = productFile.get('risk');
        const allowedRiskIndicator = flagBasedFeatures.get('landing_risk_indicator');
        const brokerIAFlag = flagBasedFeatures.get(NOT_ALLOWED_WEALTH_BROKER_IA_COUNTRIES);
        const brokerIAEnabled = !!brokerIAFlag && !brokerIAFlag.includes(immProfile.get('originCountry'));
        const brokerIAVisible = brokerIAEnabled && productFile.get('isFetched') && predictionDetail.get('isFetched')

        const mappingBreadcrumb = [
            {
                text: formatText('breadcrumb-brokerInvestments'),
                url: '/myprofile/broker'
            },
            {
                text: formatText('breadcrumb-brokerAdvancedSearch'),
                url: `/myprofile/broker/explore`
            },
            {
                text: productFile.get('companyName'),
                url: ''
            }
        ];

        return (
            <div>
                <div className="container-fluid">
                    <div className="row">
                        <OKCover size="medium" section="broker" customClass="col-xs-12">
                            <BrokerTruncatedBreadcrumb
                                titleKey="broker-productFileTitle"
                                breadcrumbConfig={mappingBreadcrumb}
                                subtitleLeft={productFileSubTitleStocks}>
                                <OKButton
                                    onClick={() => taggingEventHandled(PROC_BROKER__PRODUCT_FILE, 'brokerProductFileSearch')}
                                    inverse={true}
                                    modifier="ghost"
                                    to={MYPROFILE_BROKER_EXPLORE_URL}>
                                    <FormattedText value="broker-goToAdvancedSearch" />
                                </OKButton>
                                <FeatureTogglingRender notAllowedProductKey={OPENTRADER}>
                                    <WebappRender>
                                        <OKButton
                                            inverse={true}
                                            modifier="primary"
                                            onClick={() => {
                                                taggingEventHandled(PROC_BROKER__PRODUCT_FILE, 'brokerProductFileTrader')
                                                onOpenTraderClick()
                                            }}>
                                            <FormattedText format="firstUppercase" value="broker-openTraderLabel" />
                                        </OKButton>
                                    </WebappRender>
                                </FeatureTogglingRender>
                            </BrokerTruncatedBreadcrumb>
                        </OKCover>
                    </div>
                </div>
                <div className="grid-view__body">
                    <div className="container-fluid">
                        {
                            allowedRiskIndicator && (
                                <div className="broker-product-file-view__broker-stocks-risk-indicator">
                                    <div className="broker-product-file-view__broker-stocks-risk-indicator-numbers">
                                        <span className="broker-product-file-view__broker-stocks-risk-indicator-numbers--left" >{`${riskScale} `}</span>
                                        <span>/ 6</span>
                                    </div>
                                    <span className="broker-product-file-view__broker-stocks-risk-indicator-content" >
                                        {formatText('broker-productFileRiskIndicatorContent')}
                                    </span>
                                </div>
                            )}
                        <div className="row grid-view--content-position-negative broker-product-file-view--content-position-stocks">

                            <div className="col-xs-12">
                                <BrokerStocksHeader
                                    productFile={productFile}
                                    immMyInvestments={immMyInvestments}
                                    handleUpdate={this.getProductDetails}
                                    isin={isin}
                                    iso={iso}
                                    fireTaggingBuyButton={(isin) => taggingEventHandled(PROC_BROKER__PRODUCT_FILE, 'brokerProductFileBuy', isin)}
                                    immFlagBasedFeatures={immFlagBasedFeatures}
                                />
                            </div>

                            {brokerIAVisible &&
                                <div className="col-xs-12">
                                    {this.renderPredictionDetail()}
                                </div>
                            }

                            <FeatureTogglingRender notAllowedProductKey={STOCK_DETAILS} >
                                <div className="col-xs-12 grid-view--fix-cell-separation">
                                    {this.renderProductFileContent()}
                                </div>
                            </FeatureTogglingRender>
                        </div>
                        {brokerIAVisible && <Disclaimers product={true} />}
                    </div>
                </div>
            </div>
        );
    }
}

BrokerProductFileView.propTypes = {
    immMyInvestments: PropTypes.object.isRequired,
    getProductDetails: PropTypes.func,
    getProductCatalogueDetails: PropTypes.func,
    match: PropTypes.object,
    productFile: PropTypes.object,
    onOpenTraderClick: PropTypes.func.isRequired,
    immProfile: PropTypes.object,
    flagBasedFeatures: PropTypes.object,
    checkPersonalInformationData: PropTypes.func,
    getPredictionDetail: PropTypes.func,
    predictionDetail: PropTypes.object,
    immFlagBasedFeatures: PropTypes.object


};

module.exports.constructor = BrokerProductFileView;
module.exports.BrokerProductFileView = withRouter(connect(
    state => ({
        productFile: state.brokerProductFile,
        immMyInvestments: state.brokerMyInvestments,
        immProfile: state.profile,
        flagBasedFeatures: state.flagBasedFeatures,
        predictionDetail: state.brokerIAPredictionDetail,
        immFlagBasedFeatures: state.flagBasedFeatures,
    }), {
    getProductDetails: ProductFileActions.getProductFile,
    getProductCatalogueDetails: ProductFileActions.getStocksCatalogueDetails,
    onOpenTraderClick: BrokerOpenTraderActions.openLink,
    checkPersonalInformationData: BrokerClientWarningModalAction.checkPersonalInformationData,
    getPredictionDetail: PredictionDetailActions.getPredictionDetail
})(BrokerProductFileView));
